import config from "./config";

const stripQuotes = (value) => value.replace(/^"|"$/g, "");

const readAuthTokensFromHeaders = (headers) => {
  const accessToken = headers.get("x-patient-token") || undefined;
  const refreshToken = headers.get("x-patient-refresh-token") || undefined;
  return { accessToken, refreshToken };
};

const persistAuthTokens = ({ accessToken, refreshToken }) => {
  if (typeof accessToken === "string" && accessToken) {
    localStorage.setItem("patientAccessToken", accessToken);
  }
  if (typeof refreshToken === "string" && refreshToken) {
    localStorage.setItem("patientRefreshToken", refreshToken);
  }
};

const makeRequest = async ({ route, method, data }) => {
  const token = localStorage.getItem("patientAccessToken");
  const refreshToken = localStorage.getItem("patientRefreshToken");
  const baseUrl = config.api.baseUrl;

  const isFormData = typeof FormData !== "undefined" && data instanceof FormData;

  const headers = {
    ...(token ? { "x-patient-token": stripQuotes(token) } : {}),
    ...(refreshToken ? { "x-patient-refresh-token": stripQuotes(refreshToken) } : {}),
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
  };

  const fetchOptions = {
    method: method.toUpperCase(),
    headers,
    ...(data !== undefined && method.toLowerCase() !== "get" ? { body: isFormData ? data : JSON.stringify(data) } : {}),
  };

  try {
    const response = await fetch(`${baseUrl}${route}`, fetchOptions);

    persistAuthTokens(readAuthTokensFromHeaders(response.headers));

    const responseData = await response.json().catch(() => ({}));

    if (!response.ok) {
      const error = new Error(responseData?.error || "Request failed");
      error.response = { data: responseData, status: response.status };
      throw error;
    }

    return responseData;
  } catch (error) {
    console.error("API request error:", error?.response?.data || error?.message);
    throw error;
  }
};

export default makeRequest;
